<template>
  <div class="container">
    <div style="width: 60%">
      <img
        style="margin-left: 10%; width: 60%"
        :src="require('@/assets/imgs/logo_dfbx_0.png')"
      />
    </div>

    <div class="title">
      <div style="height: 11rem">
        <div
          class="layui-upload"
          style="width: 100%; display: flex; justify-content: center"
        >
          <div
            id="bankCard"
            class="cardImage layui-upload-list"
            style="height: 10.5rem; width: 80%; border: 1px dashed #000"
          >
            <img
              style="width: 100%; height: 100%"
              :src="imgUrl"
              class="layui-upload-img"
              @click="handleUploadClick"
            />
            <p id="demoText"></p>
          </div>
        </div>
        <input
          type="file"
          ref="rfile"
          @change="handleUploadChange"
          style="display: none"
          accept="image/*"
        />
      </div>
      <div
        style="
          height: 2rem;
          line-height: 2rem;
          margin-left: 10%;
          margin-right: 10%;
        "
      >
        <span>银行卡</span>
        <input
          type="text"
          v-model="dataForm.bankCardNumber"
          style="height: 1.8rem; padding-left: 0.2rem; margin-left: 5px"
        />
      </div>
      <div
        style="
          height: 2rem;
          line-height: 2rem;
          margin-left: 10%;
          margin-right: 10%;
        "
      >
        <span>验证码</span>
        <input
          type="text"
          v-model="dataForm.code"
          style="height: 1.8rem; padding-left: 0.2rem; margin-left: 5px"
        />
      </div>
      <div
        style="
          margin-left: 10%;
          margin-right: 10%;
          color: #ff2222;
          font-size: 0.8rem;
          margin-bottom: 0.5rem;
        "
      >
        <span
          >1.本次上传银行卡用于阳光保险公司给您支付理赔款，请务必上传被保险人本人银行卡，避免造成赔款支付失败带来不便。</span
        >
      </div>
      <div
        style="
          margin-left: 10%;
          margin-right: 10%;
          color: #ff2222;
          font-size: 0.8rem;
          margin-bottom: 0.5rem;
        "
      >
        <span
          >2.为确保您及时收到理赔款，请尽量上传工、农、中、建四大行银行卡。</span
        >
        <span>谢谢您的理解与支持！</span>
      </div>
    </div>

    <div style="margin-left: 10%; font-size: 1.35rem; font-weight: 600">
      <span>如有疑问请致电</span>
    </div>
    <div style="margin-left: 10%; padding-bottom: 0.2rem; color: #666666">
      <p>理赔客服电话：0377 60380518</p>
    </div>
    <div
      style="
        margin-left: 10%;
        padding-top: 0.2rem;
        padding-bottom: 0.2rem;
        color: #666666;
      "
    >
      <p>北京东方保险经纪有限公司南阳分公司</p>
      <p>地址：河南省南阳市卧龙区七一路139号</p>
      <p>联系电话：0377-61621899</p>
    </div>
    <div style="margin-left: 10%; padding-bottom: 0.2rem; color: #666666">
      <p>阳光保险南阳中心支公司</p>
      <p>地址：河南省南阳市宛城区张衡东路2016号</p>
      <p>联系电话：:0377-66075600</p>
    </div>

    <div style="margin-left: 20%; padding-bottom: 1.2rem; width: 60%">
      <img
        style="margin-left: 20%; width: 60%"
        :src="require('@/assets/imgs/logo_sinosig_0.png')"
      />
    </div>
    <div style="height: 5rem"></div>
    <div class="button-save">
      <van-button @click="handleGoClick" type="primary" block color="#FFC281'"
        >已确认银行卡号并上传</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast, Notify } from "vant";
import { getBank, uploadBankCard } from "@/api/common";
export default {
  data() {
    return {
      imgUrl: require("@/assets/imgs/icon_scyhk.png"),
      dataForm: {
        bankCardNumber: "",
        validDate: "",
        bankCardType: "",
        bankName: "",
        insureId: "",
        code: "",
        urlBankCard: "",
      },
    };
  },
  created() {
    document.title = "上传银行卡照片";
    this.dataForm.insureId = this.$route.query.insureId;
  },
  methods: {
    handleUploadClick() {
      this.$refs.rfile.click();
    },
    handleUploadChange(e) {
      let oFile = e.target.files[0];
      let fd = new FormData();
      fd.append("file", oFile);
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });
      var reader = new FileReader();
      reader.readAsDataURL(oFile);
      reader.onload = (e) => {
        this.imgUrl = e.target.result;
      };
      getBank(fd).then((res) => {
        Toast.clear();
        if (res.code == 0) {
          this.dataForm.urlBankCard = res.data.url;
          let result = res.data.result;
          if (!this.$ComTools.isEmptyString(result)) {
            this.dataForm.bankCardNumber = result.card_number;
            this.dataForm.validDate = result.expiry_date;
            this.dataForm.bankCardType = result.type;
            this.dataForm.bankName = result.bank_name;
          }
        } else {
          Notify(res.msg);
        }
      });
    },
    handleGoClick() {
      if (this.$ComTools.isEmptyString(this.dataForm.urlBankCard)) {
        return Toast("请上传银行卡正面");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.bankCardNumber)) {
        return Toast("请上传正确的银行卡");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.code)) {
        return Toast("请输入验证码");
      }
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });
      uploadBankCard(this.dataForm).then((res) => {
        Toast.clear();
        if (res.code == 0) {
          let content =
            "我们将在1-5个工作日将理赔款打到您的账号，如5个工作日内未收到理赔款，请联系理赔客服。联系电话：0377 60380518";
          Dialog.alert({
            title: "银行卡上传成功",
            message: content,
          }).then(() => {
            // on close
          });
        } else {
          Notify(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 1rem;
  .button-save {
    /deep/ .van-button {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      // color: black !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/insurance/bank_card.vue